import { EmailStatus } from '@40seas/entities/emails';
import { EnumColor } from '@40seas/frontend/common/providers';

export const emailStatusColorMapping = {
    [EmailStatus.Processed]: 'info',
    [EmailStatus.Unprocessed]: 'default',
    [EmailStatus.Delivered]: 'info',
    [EmailStatus.Clicked]: 'success',
    [EmailStatus.Opened]: 'success',
    [EmailStatus.Bounced]: 'error',
    [EmailStatus.Dropped]: 'error',
    [EmailStatus.Deferred]: 'warning',
} as { [key in EmailStatus]: EnumColor };
